export default "__VITE_ASSET__B1aFVZO5__"